import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconPrev: React.FC<IconProps> = ({ width = 20, height = 20, color = '#DFEAFF' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill={color}
        >
            <path
                d="M2.92969 7.42188H9.57031C9.89391 7.42188 10.1562 7.15953 10.1562 6.83594C10.1562 6.51234 9.89391 6.25 9.57031 6.25H2.92969C2.60609 6.25 2.34375 6.51234 2.34375 6.83594C2.34375 7.15953 2.60609 7.42188 2.92969 7.42188Z"
                fill="black"
            />
            <path
                d="M8.00781 8.59375H2.92969C2.60609 8.59375 2.34375 8.85609 2.34375 9.17969C2.34375 9.50328 2.60609 9.76562 2.92969 9.76562H8.00781C8.33141 9.76562 8.59375 9.50328 8.59375 9.17969C8.59375 8.85609 8.33141 8.59375 8.00781 8.59375Z"
                fill="black"
            />
            <path
                d="M8.00781 10.9375H2.92969C2.60609 10.9375 2.34375 11.1998 2.34375 11.5234C2.34375 11.847 2.60609 12.1094 2.92969 12.1094H8.00781C8.33141 12.1094 8.59375 11.847 8.59375 11.5234C8.59375 11.1998 8.33141 10.9375 8.00781 10.9375Z"
                fill="black"
            />
            <path
                d="M8.00781 13.2812H2.92969C2.60609 13.2812 2.34375 13.5436 2.34375 13.8672C2.34375 14.1908 2.60609 14.4531 2.92969 14.4531H8.00781C8.33141 14.4531 8.59375 14.1908 8.59375 13.8672C8.59375 13.5436 8.33141 13.2812 8.00781 13.2812Z"
                fill="black"
            />
            <path
                d="M19.8284 16.519L16.8984 13.589C18.1003 11.9837 17.9723 9.69109 16.5138 8.23258C16.1398 7.85855 15.7061 7.5659 15.2344 7.36301V4.49219C15.2344 4.3368 15.1727 4.18777 15.0627 4.07789L11.1566 0.171641C11.0468 0.0617578 10.8977 0 10.7423 0H2.14844C0.963789 0 0 0.963789 0 2.14844V17.8516C0 19.0362 0.963789 20 2.14844 20H13.0859C14.2706 20 15.2344 19.0362 15.2344 17.8516V14.9026C15.5297 14.7756 15.81 14.6134 16.0702 14.418L18.9997 17.3476C19.1141 17.462 19.2641 17.5192 19.414 17.5192C19.5639 17.5192 19.7139 17.462 19.8283 17.3476C20.0572 17.1188 20.0572 16.7478 19.8284 16.519ZM15.6852 13.2044C15.3462 13.5434 14.9387 13.7885 14.4941 13.928C14.4804 13.9317 14.467 13.9359 14.4538 13.9405C14.1846 14.0207 13.9023 14.0625 13.6136 14.0625C12.8311 14.0625 12.0953 13.7578 11.542 13.2044C10.9886 12.6511 10.6839 11.9154 10.6839 11.1328C10.6839 10.3503 10.9886 9.61457 11.542 9.06121C12.0953 8.50785 12.8311 8.20312 13.6136 8.20312C13.9024 8.20312 14.1848 8.24492 14.454 8.32512C14.4671 8.32973 14.4803 8.33387 14.4938 8.33754C14.9386 8.47703 15.3462 8.72219 15.6852 9.06117C16.8275 10.2035 16.8274 12.0621 15.6852 13.2044ZM13.2339 3.90625H11.3281V2.00055L13.2339 3.90625ZM14.0625 17.8516C14.0625 18.39 13.6244 18.8281 13.0859 18.8281H2.14844C1.60996 18.8281 1.17188 18.39 1.17188 17.8516V2.14844C1.17188 1.60996 1.60996 1.17188 2.14844 1.17188H10.1562V4.49219C10.1562 4.81578 10.4186 5.07812 10.7422 5.07812H14.0625V7.05566C13.9144 7.03965 13.7646 7.03125 13.6136 7.03125C12.518 7.03125 11.488 7.45789 10.7134 8.23258C9.93867 9.00727 9.51203 10.0373 9.51203 11.1328C9.51203 12.2284 9.93867 13.2584 10.7134 14.033C11.488 14.8077 12.518 15.2344 13.6136 15.2344C13.7646 15.2344 13.9144 15.226 14.0625 15.21V17.8516Z"
                fill="black"
            />
        </svg>
    );
};

export default IconPrev;
